import { render, staticRenderFns } from "./api-webhooks.vue?vue&type=template&id=5e98323c&"
import script from "./api-webhooks.vue?vue&type=script&lang=js&"
export * from "./api-webhooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports